module.exports = __webpack_public_path__ + "static/media/Graph_Para-Priv.5a5910ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Graph_Para-Priv.png
// module id = 158
// module chunks = 1